

export class BaseHttpService {

    constructor({ endpoints = {} } = {}) {

		this._endpoints = endpoints;
		return this;
	}

	getUrl(endpointName = '', params = {}) {
		const { url: endpointBuilder = (() => ''), baseUrl = '' } = this._endpoints.find(({ name }) => name === endpointName) || {};
		const path = endpointBuilder({ ...params });
		
		return `${baseUrl}/${path}`;
	}
};